import { Link } from "react-router";
import styled from "styled-components";

import { btcToString, truncateHash } from "./utils";

const SHOWN = 4;

const Panel = styled.section`
  border: 1px solid #3f3f44;
  border-left: 3px solid #32a1ce;
  border-radius: 4px;
  padding: 0.6rem 0.8rem;
  margin-bottom: 1rem;
`;

const Heading = styled.h3`
  margin: 0 0 0.15rem 0;
  font-size: 0.95rem;
`;

const Explainer = styled.p`
  margin: 0 0 0.4rem 0;
  font-size: 0.75rem;
  color: #a3abba;
  max-width: 80ch;
`;

const Empty = styled.p`
  margin: 0;
  font-size: 0.8rem;
  color: #a3abba;
`;

const Hit = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.15rem 0.6rem;
  padding: 0.25rem 0;
  border-top: 1px dotted #3f3f44;
  font-size: 0.85rem;
`;

const Label = styled(Link)`
  font-weight: bold;
  text-decoration: none;
`;

const Direction = styled.span`
  color: #a3abba;
`;

const Amount = styled.span`
  color: #26a65b;
  margin-left: auto;
  white-space: nowrap;
`;

const fmtTime = (date) =>
  date.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", second: "2-digit" });

// The coloured bars in the tape and chart are easy to miss, and a tagged
// transaction scrolls out of a hundred-row feed within seconds. This keeps the
// last few where they can be read, and explains what the highlight means even
// when nothing has matched yet - which is most of the time.
const KnownWalletActivity = ({ transactions }) => {
  const hits = [];
  for (const tx of transactions) {
    if (tx.tags && tx.tags.length > 0) hits.push(tx);
    if (hits.length === SHOWN) break;
  }

  return (
    <Panel>
      <Heading>Known wallet activity</Heading>
      <Explainer>
        Transactions involving a wallet from the{" "}
        <Link to="/btc-explorer">notable list</Link> — exchanges, government
        seizures, whales. Shown in blue above.
      </Explainer>

      {hits.length === 0 ? (
        <Empty>None in the last few blocks — they are uncommon.</Empty>
      ) : (
        hits.map((tx) =>
          tx.tags.map((tag) => (
            <Hit key={`${tx.hash}-${tag.address}`}>
              <Label to={`/btc-explorer/${tag.address}`}>{tag.label}</Label>
              <Direction>
                {tag.direction} ·{" "}
                {tx.seeded
                  ? `block ${tx.height.toLocaleString()}`
                  : fmtTime(tx.time)}{" "}
                ·{" "}
                <Link to={`/btc-explorer/${tx.hash}`}>{truncateHash(tx.hash)}</Link>
              </Direction>
              <Amount>{btcToString(tx.netMovedBtc)} BTC</Amount>
            </Hit>
          ))
        )
      )}
    </Panel>
  );
};

export default KnownWalletActivity;
